import { render } from "./OTPModal.vue?vue&type=template&id=7b223b90&scoped=true"
import script from "./OTPModal.vue?vue&type=script&lang=js"
export * from "./OTPModal.vue?vue&type=script&lang=js"

import "./OTPModal.vue?vue&type=style&index=0&id=7b223b90&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b223b90"]])

export default __exports__